/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersImportTemplateResponse } from '../../models/users-import-template-response';

export interface GetUsersImportTemplate$Params {
  'Active-Tenant-Identifier': string;
}

export function getUsersImportTemplate(http: HttpClient, rootUrl: string, params: GetUsersImportTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportTemplateResponse>> {
  const rb = new RequestBuilder(rootUrl, getUsersImportTemplate.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersImportTemplateResponse>;
    })
  );
}

getUsersImportTemplate.PATH = '/users-import-template';
